import { Link, useNavigate } from "react-router-dom";
import PaymentSuccessful from "../../../../assets/images/PaymentIcons/PaymentSuccessful.gif";
import { useEffect } from "react";
import { useStripe } from "@stripe/react-stripe-js";
import { useState } from "react";
import { LoadingIcon } from "../../../common";
import {
  useUserSubscriptionMutation,
  useGetCompanyQuery,
  useGetClaimedMutation,
  useCreatePurchaseDetailsMutation,
} from "../../../../store/Company/companyApiSlice";
import { useDispatch, useSelector } from "react-redux";
import { CommonToast } from "../../../common/Toast";
import { setUserInfo } from "../../../../store/auth/authSlice";
import { useCheckPaymentStatusMutation } from "../../../../store/Billing/billingApiSlice";

export const SuccessfulPayment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    dispatch(setUserInfo({ ...userInfo }));
  }, [])
  const stripe = useStripe();
  const [userSubscription] = useUserSubscriptionMutation();
  const [createPurchaseDetails] = useCreatePurchaseDetailsMutation();
  const [checkPaymentStatus] = useCheckPaymentStatusMutation();
  const [verificationRequest] = useGetClaimedMutation();
  const [hasCalledAPI, setHasCalledAPI] = useState(false);
  const [redirectionType, setredirectionType] = useState("");
  const { token, userInfo } = useSelector((state) => state.auth);
  const [paymentStatus, setPaymentstatus] = useState('LOADING');

  const getPaymentStatus = async (id, setup) => {
    if (id) {
      const data = setup ? { setup_intent: id } : { payment_intent: id };
      const response = await checkPaymentStatus({ data, token });
      return response;
    }
  };
  const forCompanyVerify = new URLSearchParams(window.location.search).get(
    "companyforverify"
  );
  const forCompanyVerifyID = new URLSearchParams(window.location.search).get(
    "forverifycompid"
  );

  const individualID = userInfo?.individual[0]?.individualID;
  const UserID = userInfo?.individual[0]?.userID;
  const companyDataString = localStorage.getItem("payasyougoCompanyID");
  const payforcompanyID = JSON.parse(companyDataString);

  const { data } = useGetCompanyQuery({
    companyId: payforcompanyID,
    token,
  });

  useEffect(() => {
    const payment_intent = new URLSearchParams(window.location.search).get(
      "payment_intent"
    );

    localStorage.removeItem("createWorldbox")
    localStorage.removeItem("createWorldboxCompany")
    localStorage.removeItem("worldboxData")
    localStorage.removeItem("companyDescription")
    localStorage.removeItem("payasyougoCompanyID")
    localStorage.removeItem("paycompanyStatus")
    localStorage.removeItem("UpgradePlan");
    const clientSecret = new URLSearchParams(window.location.search).get(payment_intent ? "payment_intent_client_secret" : "setup_intent_client_secret");

    let subscriptionType, subscriptionEnd, profileLimit;

    const paymentBilling = async (res) => {
      try {
        localStorage.removeItem("UpgradePlan");
        localStorage.removeItem("userInfo");
        if (forCompanyVerify !== "verify_company") {
          setredirectionType("purchase");
        } else if (forCompanyVerifyID) {
          setredirectionType("verifycompany");
        } else {
          setredirectionType("billing");
        }
      } catch (error) {
        console.error("Error fetching client secret:", error);
      }
    };

    if (clientSecret && !hasCalledAPI) {
      if (stripe && clientSecret && payment_intent) {
        stripe
          .retrievePaymentIntent(clientSecret)
          .then(async (paymentIntent) => {
            if (paymentIntent.paymentIntent?.status === "succeeded") {
              let checks = 0;
              const maxChecks = 8;
              const interval = setInterval(async () => {
                const status = await getPaymentStatus(paymentIntent?.paymentIntent?.id, false);
                if (status) {
                  if (status?.data?.status === "completed") {
                    setPaymentstatus('SUCCESS')
                    clearInterval(interval);
                    paymentBilling(paymentIntent);
                  } else if (status?.data?.status === "failed") {
                    CommonToast.error("Payment Failed");
                    clearInterval(interval);
                    setPaymentstatus('FAILED');
                    paymentBilling(paymentIntent);
                  } else {
                    checks++;
                    if (checks >= maxChecks) {
                      clearInterval(interval);
                      setPaymentstatus('PENDING');
                      paymentBilling(paymentIntent);
                    }
                  }
                }
              }, 5000);

              localStorage.removeItem("createWorldbox");
              localStorage.removeItem("worldboxData");
            }
          });

        setHasCalledAPI(true);
      } else if (stripe && clientSecret) {
        stripe.retrieveSetupIntent(clientSecret).then(async (intent) => {
          if (intent.setupIntent?.status === "succeeded") {
            let checks = 0;
            const maxChecks = 8;
            const interval = setInterval(async () => {
              const status = await getPaymentStatus(intent?.setupIntent?.id, true);
              if (status) {
                if (status?.data?.status === "completed") {
                  setPaymentstatus('SUCCESS')
                  clearInterval(interval);
                  paymentBilling(intent);
                } else if (status?.data?.status === "failed") {
                  CommonToast.error("Payment Failed");
                  clearInterval(interval);
                  setPaymentstatus('FAILED');
                  paymentBilling(intent);
                } else {
                  checks++;
                  if (checks >= maxChecks) {
                    clearInterval(interval);
                    setPaymentstatus('PENDING');
                    paymentBilling(intent);
                  }
                }
              }
            }, 5000);

            localStorage.removeItem("createWorldbox");
            localStorage.removeItem("worldboxData");
          }
        });

        setHasCalledAPI(true);
      }
    }
  }, [
    stripe,
    data,
    hasCalledAPI,
    userSubscription,
    individualID,
    forCompanyVerifyID,
    verificationRequest,
    token,
    UserID,
    payforcompanyID,
    createPurchaseDetails,
  ]);

  return (
    <>
      <div className="bg-[#ebf0f3]">
        {paymentStatus === 'SUCCESS' || paymentStatus === 'LOADING' ? <div>
          {redirectionType == "verifycompany" ? (
            <div className="mx-auto py-10 relative pb-40">
              <img
                src={PaymentSuccessful}
                className="mx-auto sm:w-[400px]"
                alt="payment-successful"
              />
              <h2 className="text-f24 font-extrabold">Payment Successful</h2>
              <p className="text-secondary">
                Your purchase has been completed — return to your
                <span onClick={() => { navigate("/dashboard/my-companies", { state: { userInfo: userInfo } }) }} className="text-[#002940]"> Company details</span>
              </p>
            </div>
          ) : redirectionType == "billing" ? (
            <div className="mx-auto py-10 relative pb-40">
              <img
                src={PaymentSuccessful}
                className="mx-auto sm:w-[400px]"
                alt="payment-successful"
              />
              <h2 className="text-f24 font-extrabold">Payment Successful</h2>
              <p className="text-secondary">
                Your purchase has been completed — return to your<span onClick={() => { navigate("/dashboard/billing") }} className="text-[#002940]"> Billing details</span>
              </p>
            </div>
          ) : redirectionType == "purchase" ? (
            <div className="mx-auto py-10 relative pb-40">
              <img
                src={PaymentSuccessful}
                className="mx-auto sm:w-[400px]"
                alt="payment-successful"
              />
              <h2 className="text-f24 font-extrabold">Payment Successful</h2>
              <p className="text-secondary">
                Your purchase has been completed — return to your
                <span onClick={() => { navigate("/dashboard/purchased") }} className="text-[#002940]"> Dashboard</span>
              </p>
            </div>
          ) : (
            <div className="mx-auto py-10 relative pb-40">
              <img
                src={PaymentSuccessful}
                className="mx-auto sm:w-[400px] hiddenlogo"
                alt="payment-successful"
              />
              <LoadingIcon />
            </div>
          )}
        </div> : paymentStatus === 'PENDING' ? (
          <div className="mx-auto py-10 relative pb-40 h-screen flex flex-col justify-center">
            {/* <img
              src={PaymentSuccessful}
              className="mx-auto sm:w-[400px]"
              alt="payment-successful"
            /> */}

            <h2 className="text-f24 font-extrabold">Payment Pending</h2>
            <p className="text-secondary">
              Payment is taking too long to process then expected,
              <span onClick={() => { navigate("/") }} className="text-[#002940]"> Home</span>
            </p>
          </div>
        ) : paymentStatus === 'FAILED' ? (
          <div className="mx-auto py-10 relative pb-40 h-screen flex flex-col justify-center">
            {/* <img
              src={PaymentSuccessful}
              className="mx-auto sm:w-[400px]"
              alt="payment-successful"
            /> */}
            <h2 className="text-f24 font-extrabold">Payment Failed</h2>
            <p className="text-secondary">
              Payment Failed please try again,
              <Link to="/" reloadDocument>
                <span className="text-[#002940]"> Home</span>
              </Link>
            </p>
          </div>
        ) : null}
      </div>
    </>
  );
};